import ContactUs from './ContactUs.page';

export default ContactUs;